import { CACHE_KEY } from '@/utils/constant'
import store from '@/store'
import Vue from 'vue'

/**
 * 通过uid与本地存储的所有用户信息比对，映射出uid对应的详细用户信息
 * @param list uid list集合
 * @param hasUid 是有带有uid|,树形结构组织列表人员是以uid|开头，其余没有
 * @returns {*[]} 返回映射后的用户信息集合
 */
export function userMapperInfo(list, hasUid) {
  const userList = (Vue.ss.get(`${CACHE_KEY.user}_own`) || [])
    .concat(Vue.ss.get(`${CACHE_KEY.user}_ext`) || [])
  // 是自己的好友，映射好友信息
  const friendsInfo = []
  // 不是自己的好友，返回id的数组集合
  const notFriendIds = []
  userList.forEach(el => {
    if (list.some(ele => (hasUid ? ele.split('|')[1] : ele) === el.uid)) {
      friendsInfo.push(el)
    }
  })
  list.forEach(el => {
    if (!userList.some(ele => ele.uid === (hasUid ? el.split('|')[1] : el))) {
      notFriendIds.push(el)
    }
  })
  if (notFriendIds.length) store.dispatch('sessionAdd/getAllNotFriendsInfo', notFriendIds)
  return friendsInfo
}
